'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { applyLandingLanguage, useLandingLanguage } from '@/hooks/useLandingLanguage';
import { getGuide, type GuideSlug } from '@/lib/cadrino-landing/guides-copy';
import { useWebsitePagesCopy } from '@/lib/cadrino-landing/useWebsitePagesCopy';
import { CadrinoMarketingHeader } from './CadrinoMarketingHeader';
import { CadrinoFooter } from './CadrinoFooter';
import { ContactSection } from './ContactSection';
import { MarketingHero } from './MarketingHero';
import { CadrinoShell, Container, MotionBlock, Section } from './shared';
export function CadrinoGuidePage(t0) {
  const $ = _c(9);
  const {
    slug
  } = t0;
  const {
    language
  } = useLandingLanguage();
  const guide = getGuide(slug, language);
  const pages = useWebsitePagesCopy();
  let t1;
  let t2;
  if ($[0] !== language) {
    t1 = () => {
      applyLandingLanguage(language);
    };
    t2 = [language];
    $[0] = language;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (!guide) {
    return null;
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CadrinoMarketingHeader />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== guide.cta.body || $[5] !== guide.cta.button || $[6] !== guide.cta.title) {
    t4 = <ContactSection title={guide.cta.title} subtitle={guide.cta.body} primaryLabel={guide.cta.button} primaryHref="#contact-form" />;
    $[4] = guide.cta.body;
    $[5] = guide.cta.button;
    $[6] = guide.cta.title;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <CadrinoFooter />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return <CadrinoShell>{t3}<main><MarketingHero variant="inner" eyebrow={guide.eyebrow} title={guide.title} subtitle={guide.subtitle} primaryCtaLabel={guide.cta.button} primaryCtaHref="#contact" secondaryCtaLabel={pages.nav.product} secondaryCtaHref="/product" />{guide.sections.map(_temp2)}{t4}</main>{t5}</CadrinoShell>;
}
function _temp2(section, index) {
  return <Section key={section.title} className={index % 2 === 1 ? "border-t border-white/[0.08] bg-cadrino-surface/30" : "border-t border-white/[0.08]"}><Container><MotionBlock><h2 className="text-xl font-semibold text-slate-100">{section.title}</h2><p className="mt-4 max-w-3xl text-sm leading-relaxed text-cadrino-muted">{section.body}</p>{section.bullets && <ul className="mt-4 list-inside list-disc space-y-2 text-sm text-slate-300">{section.bullets.map(_temp)}</ul>}</MotionBlock></Container></Section>;
}
function _temp(b) {
  return <li key={b}>{b}</li>;
}